export default {

  //заполнить одобренные акции
    loadPublished(state, data){
        state.publishedItems=data;
    },

    //заполнить акции в обработке
    loadActive(state, data){
        state.activeItems=data;
    },

    setOrgItems(state, data){
      state.orgItems=data
    },

}
